module.exports = __webpack_public_path__ + "static/img/mb_spot_service_umy.6fe80219.png";